@if (!loading) {
  @if (paymentPages.count < 2) {
    <sps-payment-page [paymentPageData]="paymentPageData"
                      (addNewPaymentPage)="onAddNewPaymentPage($event)"
                      (changePaymentPage)="onUpdatedPaymentPage($event)"
                      [scrollHeightOffset]="154">
    </sps-payment-page>
  } @else {
    <div class="grid">
      <div class="col-12">
        <p-tabs [value]="activePaymentPage" scrollable>
          <p-tablist>
            @for (paymentPage of paymentPages.pages; track paymentPage) {
              <p-tab [value]="paymentPage.id">{{ paymentPage.name }}</p-tab>
            }
          </p-tablist>
          <p-tabpanels>
            @for (paymentPage of paymentPages.pages; track paymentPage) {
              <p-tabpanel [value]="paymentPage.id">
                <sps-payment-page [paymentPageData]="paymentPage"
                                  (addNewPaymentPage)="onAddNewPaymentPage($event)"
                                  (changePaymentPage)="onUpdatedPaymentPage($event)">
                </sps-payment-page>
              </p-tabpanel>
            }
          </p-tabpanels>
        </p-tabs>
      </div>
    </div>
  }
}
